import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Cart1Service } from '../services/cart1.service';

export interface PurchaseModalData {
  product: any;
}

export interface PurchaseSelection {
  isAutoship: boolean;
  quantity: number;
}

@Component({
  selector: 'app-purchase-type-modal',
  templateUrl: './purchase-type-modal.component.html',
  styleUrls: ['./purchase-type-modal.component.scss']
})
export class PurchaseTypeModalComponent implements OnInit {

  product: any;
  quantity: number = 1;
  purchaseType: 'onetime' | 'subscription' = 'onetime';
  isLoading: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<PurchaseTypeModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PurchaseModalData,
    private cart1Service: Cart1Service
  ) {
    this.product = data.product;
  }

  ngOnInit(): void {
    // Set default to subscription if autoship price is available and lower
    if (this.hasAutoshipPrice() && this.getAutoshipPrice() < this.getOneTimePrice()) {
      this.purchaseType = 'subscription';
    }
  }

  getOneTimePrice(): number {
    return this.product.Price || 0;
  }

  getAutoshipPrice(): number {
    return this.product.AutoshipPrice || this.getOneTimePrice();
  }

  hasAutoshipPrice(): boolean {
    return this.product.AutoshipPrice !== undefined && 
           this.product.AutoshipPrice !== null && 
           this.product.AutoshipPrice > 0;
  }

  getSavings(): number {
    if (this.hasAutoshipPrice()) {
      return Math.max(0, this.getOneTimePrice() - this.getAutoshipPrice());
    }
    return 0;
  }

  getSavingsPercentage(): number {
    const savings = this.getSavings();
    if (savings > 0) {
      return Math.round((savings / this.getOneTimePrice()) * 100);
    }
    return 0;
  }

  getCurrentPrice(): number {
    return this.purchaseType === 'subscription' ? this.getAutoshipPrice() : this.getOneTimePrice();
  }

  getTotalPrice(): number {
    return this.getCurrentPrice() * this.quantity;
  }

  incrementQuantity(): void {
    this.quantity++;
  }

  decrementQuantity(): void {
    if (this.quantity > 1) {
      this.quantity--;
    }
  }

  onQuantityChange(event: any): void {
    const value = parseInt(event.target.value);
    if (value && value > 0) {
      this.quantity = value;
    } else {
      this.quantity = 1;
    }
  }

  setPurchaseType(type: 'onetime' | 'subscription'): void {
    this.purchaseType = type;
  }

  addToCart(): void {
    if (this.isLoading) return;

    this.isLoading = true;
    
    const productToAdd = this.product._selectedPack || this.product;
    const isAutoship = this.purchaseType === 'subscription';

    // Set quantity on product
    productToAdd.Quantity = this.quantity;

    this.cart1Service.addToCart(
      productToAdd,
      true,  // show notification
      '',    // custom order code
      isAutoship,  // isAutoship
      true,  // fromDialog
      false, // isPack
      false, // fromApplication
      false, // fromPointbtn
      0,     // countFromSharelink
      false, // loyaltyOrder
      null   // enrollProducts
    );

    this.isLoading = false;
    this.closeModal();
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}